// Zona horaria de la cuenta (IANA). Toda fecha/hora visible se calcula con ella, no con la del móvil.
let TZ = "Europe/Madrid";
export const setZona = (tz) => { if (tz) TZ = tz; };
export const zona = () => TZ;
export const zonaDispositivo = () => { try { return Intl.DateTimeFormat().resolvedOptions().timeZone; } catch { return ""; } };

const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
const pad = (n) => String(n).padStart(2, "0");

const partes = (date = new Date()) => {
  const p = {};
  new Intl.DateTimeFormat("en-GB", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(date).forEach(({ type, value }) => { p[type] = value; });
  return { y: Number(p.year), m: Number(p.month), d: Number(p.day), h: Number(p.hour) % 24, min: Number(p.minute) };
};

export const hoyISO = () => { const p = partes(); return `${p.y}-${pad(p.m)}-${pad(p.d)}`; };
export const ahoraHM = () => { const p = partes(); return `${pad(p.h)}:${pad(p.min)}`; };
export const ahoraMin = () => { const p = partes(); return p.h * 60 + p.min; };
// ¿Ya pasó esa fecha/hora? Sin hora: deja de estar activa al terminar el día.
export const yaPaso = (fecha, hora) => { const h = hoyISO(); return !fecha || fecha < h || (fecha === h && !!hora && hora <= ahoraHM()); };
export const diaDelMes = () => partes().d;

// Suma días a una fecha de calendario "YYYY-MM-DD" (sin pasar por UTC).
export const sumarDias = (iso, dias) => {
  const [y, m, d] = iso.split("-").map(Number);
  const t = new Date(Date.UTC(y, m - 1, d + dias));
  return `${t.getUTCFullYear()}-${pad(t.getUTCMonth() + 1)}-${pad(t.getUTCDate())}`;
};

// Fecha local de un objeto Date construido como medianoche local (new Date("YYYY-MM-DDT00:00:00")).
export const isoLocal = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// Marca de tiempo guardada en UTC → "7 octubre, 17:14" en la zona de la cuenta.
export const fechaHoraCorta = (ts) => { const p = partes(new Date(ts)); return `${p.d} ${MESES[p.m - 1]}, ${pad(p.h)}:${pad(p.min)}`; };
// → "7 de octubre de 2026 · 17:14"
export const fechaHoraLarga = (ts) => { const p = partes(new Date(ts)); return `${p.d} de ${MESES[p.m - 1]} de ${p.y} · ${pad(p.h)}:${pad(p.min)}`; };
// Marca de tiempo UTC → fecha de calendario "YYYY-MM-DD" en la zona de la cuenta.
export const fechaLocalISO = (ts) => { const p = partes(new Date(ts)); return `${p.y}-${pad(p.m)}-${pad(p.d)}`; };
